<script>
    import { _err, _log } from "./utils/logger";
    import { fade } from "svelte/transition";
    import { createEventDispatcher } from "svelte";
    import { deletePreset } from "./db";
    import l from "./utils/locale";

    const dispatch = createEventDispatcher();
    export let allPreset = [];
    export let isShowAllPreset = false;
    //export let options = {};

    function onClickHandler(preset) {
        const p = preset.preset;
        const options = { ...p };
        dispatch("applePreset", options);
    }

    async function removeHandler(preset) {
        try {
            const result = await deletePreset(preset.id);
            if (result) {
                allPreset = allPreset.filter((v) => v.id !== preset.id);
            }
        } catch (error) {
            _err(error);
        }
    }

    function onClickClose() {
        isShowAllPreset = false;
    }

    function onClickNewHandler() {
        dispatch("applePresetNew", {});
        onClickClose();
    }
</script>

<div class="allPreset" on:click|stopPropagation={() => {}}>
    <div
        on:click={onClickNewHandler}
        class="app-file"
        transition:fade={{ duration: 200 }}
    >
        <div class="app-file-label-new noselect">
            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>{l["new"]}</title><path d="M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm80 224h-64v64a16 16 0 01-32 0v-64h-64a16 16 0 010-32h64v-64a16 16 0 0132 0v64h64a16 16 0 010 32z"/></svg>
            {l["new"]}
        </div>
    </div>
    {#if isShowAllPreset && allPreset.length > 0}
        {#each allPreset as preset}
            <div
                on:click={() => onClickHandler(preset)}
                class="app-file"
                transition:fade={{ duration: 200 }}
            >
                <img
                    class="app-file-img noselect"
                    src={preset.preset.preview}
                    alt=""
                />
                <!-- <div class="app-file-label-top noselect">
                    {l[preset.preset.drawMode]}
                </div> -->
                <div class="app-file-label-top noselect noselect">
                    {preset.preset.id}
                </div>
                <div
                    class="app-file-remove"
                    on:click|stopPropagation={() => removeHandler(preset)}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        viewBox="0 0 512 512"
                        ><title>{l["remove"]}</title><path
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="32"
                            d="M400 256H112"
                        /></svg
                    >
                </div>
            </div>
        {/each}

    {/if}
    
    <div class="closeAllPreset" on:click={onClickClose}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>{l["close"]}</title><path
                d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
            /></svg
        >
    </div>
</div>
